<template>
  <div>
    <header-bar class="q-pb-lg" :title="$t('title')"></header-bar>
    <q-page>
      <div v-if="!loading" style="padding: 20px;">
        <div class="q-col-gutter-lg row items-start">
          <div v-for="link in links" class="col-12 col-sm-6 col-md-4" :key="link.ID">
            <q-card v-if="link.platform === 'Ad'" class="item-card">
              <component
                :src="link.source"
                :is="script" :id="link.id" type="text/javascript" async>
              </component>
            </q-card>
            <template v-else>
              <q-card class="item-card" @click="openBottomSheet(link)">
              <q-img class="rounded-borders" :ratio="4/3" :src="link.media_screenshot_link"
                placeholder-src="https://via.placeholder.com/150?text=loading">
                <div class="absolute-top-left text-subtitle2" style="background: none;">
                  <q-spinner v-if="link.downloading" size="20px" color="blue"
                    style="position: absolute; top: 8px; left: 8px;" />
                </div>
                <template v-slot:error>
                  <div class="absolute-full flex flex-center bg-negative text-white">
                    {{ $t('cannot_load_image') }}
                  </div>
                </template>
              </q-img>
            </q-card>
            <q-card style="font-size: 14px; margin-top: 10px; box-shadow: none; background: transparent;">
              <q-item-label lines="2" style="align-self: flex-end">
                {{ link.name || link.media_url }}
              </q-item-label>
            </q-card>
            </template>
          </div>
        </div>
      </div>
    </q-page>
  </div>
</template>

<script>
/* global gtag */

/* type Platform = 'Twitter' | 'Facebook' | 'TikTok' | 'Youtube' | 'Ad'

interface Link {
  ID: number
  CreatedAt: string
  UpdatedAt: string
  DeletedAt: string | null
  favourite: string
  media_url: string
  media_parent_url: string
  media_screenshot_link: string
  name: string
  source: string
  platform: Platform
  user_id: string
  username: string
  location: string
  parent_tweet_id: string
  parent_tweet_url: string
}
*/

import { createMetaMixin } from 'quasar'
import HeaderBar from '../components/HeaderBar.vue'
import { loadIonicon } from '../components/CustomSvgIcon.vue'

import { listPublicDownloads } from '../api'
import { getDownloadSource } from '../download_sources'
import Downloader from '../utils'

export default {
  name: 'UserDownloads',

  components: { HeaderBar },

  data () {
    return {
      links: {},
      loading: true,
      script: 'script'
    }
  },

  mixins: [
    createMetaMixin({
      script: {
        propeller: {
          async: 'async',
          'data-cfasync': 'false',
          'src': '//upgulpinon.com/1?z=3318722'
        }
      }
    })
  ],

  mounted () {
    // Show loading overlay
    this.$q.loading.show({ spinnerSize: 50 })

    const self = this

    // Show an error if the content hasn't loaded after 60 seconds
    setTimeout(() => {
      if (self.loading) {
        self.$errorDialog(self.$t('error.timeout'))
      }
    }, 60000)

    const username = this.$route.params.username

    listPublicDownloads(username).then(function (response) {
      const data = response.data
      const links = self.insertAds(data)
      self.links = links
      self.loading = false
      self.$q.loading.hide()
    }).catch(function (error) {
      self.$q.loading.hide()
      if (typeof error.response !== 'undefined') {
        if (error.response.status === 404) {
          self.$errorDialog(self.$t('no_downloads_check_username'))
          self.$sentry.captureException(error)
          return
        }
      }
      self.$sentry.captureException(error)
      self.$errorDialog(self.$t('error.generic'))
    })
  },

  methods: {
    getSourceName (media) {
      const downloadSource = getDownloadSource(media)
      if (downloadSource) {
        return downloadSource.id
      }

      return ''
    },

    getIcon (media) {
      // Get the icon for a link
      const downloadSource = getDownloadSource(media)
      if (downloadSource) {
        return downloadSource.icon
      }

      return ''
    },

    async openBottomSheet (media) {
      const self = this
      const mediaLink = media.media_url
      let mediaIcon = this.getIcon(media)
      mediaIcon = await loadIonicon(mediaIcon)

      this.$q.bottomSheet({
        dismissLabel: this.$t('private.quit'),
        grid: false,
        actions: [
          {
            label: this.$t('view'),
            icon: 'movie',
            color: 'primary',
            handler () {
              const DownloadAdapter = new Downloader(self)
              DownloadAdapter.viewMedia(mediaLink)
            }
          },
          {
            label: this.$t('download'),
            icon: 'cloud_download',
            color: 'green',
            handler () {
              gtag('event', 'download_media_user_downloads', {
                'event_category': 'public_user_actions',
                'event_label': media.media_parent_url,
                value: 1
              })

              media.downloading = true // media is now reactive

              const DownloadAdapter = new Downloader(self)
              DownloadAdapter.downloadMedia(media.name || mediaLink, mediaLink, () => { media.downloading = false })
            }
          },
          {
            label: this.$t('share'),
            icon: 'share',
            color: 'primary',
            handler () {
              if (navigator.share !== undefined) {
                navigator.share({
                  title: document.title,
                  url: mediaLink
                }).then(() => console.log('Successful share'))
                  .catch((error) => console.log('Error sharing:', error))
              } else {
                self.$q.notify({ icon: 'warning', color: 'red', message: self.$t('share_feature_not_available') })
              }
            }
          },
          {
            'label': this.$t('view_on_platform', { platform: this.getSourceName(media) }),
            icon: mediaIcon,
            color: 'primary',
            handler () {
              const DownloadAdapter = new Downloader(self)
              DownloadAdapter.viewMedia(media.media_parent_url)
            }
          }
        ]
      }).onOk(action => {
        action.handler()
      })
    },

    insertAds (links) {
      const ad = {
        id: 'AV632c10157c23b1265d719e68',
        source: 'https://tg1.aniview.com/api/adserver/spt?AV_TAGID=632c10157c23b1265d719e68&AV_PUBLISHERID=632c0e58569c1006c10c9675',
        platform: 'Ad'
      }

      links.splice(1, 0, ad)

      return links
    }
  }
}
</script>
